import { useEffect } from "react";
import noUiSlider from "nouislider";

export function useSlider(sliderRef, maxValue, onChange) {
  useEffect(() => {
    if (!sliderRef.current) return;

    // Destroi slider anterior
    if (sliderRef.current.noUiSlider) {
      sliderRef.current.noUiSlider.destroy();
    }

    // Cria slider
    noUiSlider.create(sliderRef.current, {
      start: [0, maxValue],
      connect: true,
      range: {
        min: 0,
        max: maxValue,
      },
      step: 0.01,
      tooltips: false,
      format: {
        to: (value) => parseFloat(value).toFixed(2),
        from: (value) => parseFloat(value),
      },
    });

    const slider = sliderRef.current.noUiSlider;

    // Só chama quando o usuário interage de fato
    slider.on("set", (values) => {
      const min = parseFloat(values[0]);
      const max = parseFloat(values[1]);
      onChange(min, max);
    });
  }, [sliderRef, maxValue, onChange]);

  const setSliderValues = (min, max) => {
    if (sliderRef.current?.noUiSlider) {
      sliderRef.current.noUiSlider.set([min, max]);
    }
  };

  return { setSliderValues };
}
